// This file was automatically generated from appanalytics.dialog.viewMuNumDen.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appanalytics.dialog.viewMuNumDen');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.viewMuNumDen.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="view-mu-num-den-content overlayContainer"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.viewMuNumDen.details = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h3 class="el8AppColor">', soy.$$escapeHtml(opt_data.header), '</h3><p class="el8Spacer el8AppColor">Description: ', soy.$$escapeHtml(opt_data.measure), '</p>', (opt_data.csvUrl) ? '<p class="el8Spacer el8AppColor fr"><a href="' + soy.$$escapeHtml(opt_data.csvUrl) + '">Download List to Open in Excel</a></p>' : '', '<div class="el8Spacer"></div><div class="tabbed-nav el8TabHomeSection"></div><div class="el8Spacer"><div class="not-meet-criteria-list el8OverflowAuto" style="margin: 0 auto;"></div><div class="meet-criteria-list el8OverflowAuto" style="margin: 0 auto;"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.viewMuNumDen.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.list.length) {
    if (opt_data.list[0]['model_class'] == 'Patient') {
      output.append('<table class="practiceReportTable w75">');
      el8.template.appanalytics.dialog.viewMuNumDen.showPatients({list: opt_data.list}, output);
      output.append('</table>');
    } else {
      output.append('<table class="practiceReportTable">');
      el8.template.appanalytics.dialog.viewMuNumDen.showStuff({list: opt_data.list}, output);
      output.append('</table>');
    }
  } else {
    output.append('<p class="el8FeedEmpty">No entries found</p>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.viewMuNumDen.showPatients = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<thead><tr><th class="el8Bold">Patient Name</th><th class="el8Bold">D.O.B.</th></tr></thead><tbody>');
  var pList192 = opt_data.list;
  var pListLen192 = pList192.length;
  for (var pIndex192 = 0; pIndex192 < pListLen192; pIndex192++) {
    var pData192 = pList192[pIndex192];
    output.append('<tr><td class="reportIndicatorName">', (pData192['vip']) ? '<span class="el8VipTag">VIP</span>' + ((pData192['delete_date']) ? soy.$$escapeHtml(pData192['id']) + ' (Deleted)' : '<a target="_blank" rel="noopener" href="/patient/' + soy.$$escapeHtml(pData192['id']) + '/">' + soy.$$escapeHtml(pData192['id']) + '</a>') : (pData192['delete_date']) ? soy.$$escapeHtml(pData192['firstName']) + ' ' + soy.$$escapeHtml(pData192['middleName']) + ' ' + soy.$$escapeHtml(pData192['lastName']) + ' (Deleted)' : '<a target="_blank" rel="noopener" href="/patient/' + soy.$$escapeHtml(pData192['id']) + '/">' + soy.$$escapeHtml(pData192['firstName']) + ' ' + soy.$$escapeHtml(pData192['middleName']) + ' ' + soy.$$escapeHtml(pData192['lastName']) + '</a>', '</td><td>', soy.$$escapeHtml(pData192['dob']), '</td></tr>');
  }
  output.append('</tbody>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.dialog.viewMuNumDen.showStuff = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<thead><tr><th class="reportTableDate">Date</th><th class="reportContact">Type</th><th class="reportIndicatorName">Patient Name</th><th class="reportTableDate">D.O.B.</th></tr></thead><tbody>');
  var iList233 = opt_data.list;
  var iListLen233 = iList233.length;
  for (var iIndex233 = 0; iIndex233 < iListLen233; iIndex233++) {
    var iData233 = iList233[iIndex233];
    output.append('<tr><td class="reportTableDate">', soy.$$escapeHtml(iData233['documentDate']), '</td><td class="reportContact">', soy.$$escapeHtml(iData233['display_name']), '</td><td class="reportIndicatorName">', (iData233['patient']['vip']) ? '<span class="el8VipTag">VIP</span><a target="_blank" rel="noopener" href="/patient/' + soy.$$escapeHtml(iData233['patient']['id']) + '/">' + soy.$$escapeHtml(iData233['patient']['id']) + '</a>' : '<a target="_blank" rel="noopener" href="/patient/' + soy.$$escapeHtml(iData233['patient']['id']) + '/">' + soy.$$escapeHtml(iData233['patient']['firstName']) + ' ' + soy.$$escapeHtml(iData233['patient']['middleName']) + ' ' + soy.$$escapeHtml(iData233['patient']['lastName']) + '</a>', '</td><td class="reportTableDate">', soy.$$escapeHtml(iData233['patient']['dob']), '</td></tr>');
  }
  output.append('</tbody>');
  if (!opt_sb) return output.toString();
};
